import { render, staticRenderFns } from "./goodsml.vue?vue&type=template&id=4c135f10&"
import script from "./goodsml.vue?vue&type=script&lang=js&"
export * from "./goodsml.vue?vue&type=script&lang=js&"
import style0 from "./goodsml.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports